import { Button, Typography } from "@/design-system/Atoms";
import { orderColumns } from "@/design-system/Organisms/OrderHistorySection/orderTable.data";
import { TableGrid } from "@/design-system/Molecules/TableGrid";
import { DASHBOARD_TABS } from "@/constants/dashboardTabs";
import { useOrdersService } from "@/rtkQuery/features/hooks/useOrdersService";
import { AppEmptyState, AppErrorState } from "@/design-system/Feedbacks";
import OrderTableShimmer from "@/design-system/Organisms/OrderHistorySection/OrderTableShimmer";
import { useScrollToTopOnMount } from "@/hooks/useScrollToTopOnMount";
import { useState } from "react";
import ContactANurseModal from "@/design-system/Molecules/ContactNurseModal";

interface OrderModal { 
  orderId: number;
  productName: string;
}

export const RequestANurseSection = () => {
  useScrollToTopOnMount();
  const { orders, ordersIsLoading, ordersError } = useOrdersService(); 

  const [OrderModal, setOrderModal] = useState<OrderModal | null>(null);

  const [isContactNurseModalOpen, setIsContactNurseModalOpen] =
    useState(false);

  const handleRowClick = (orderId: number,productName:string) => {
    
    setOrderModal({ orderId, productName });
    setIsContactNurseModalOpen(true);
  };

  const closeContactNurseModal = () => {
    setIsContactNurseModalOpen(false);
  };
  const capitalize = (text: string | null | undefined) =>
    text
      ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
      : "Unknown";
  return (
    <>
      <div className="rounded-[20px] bg-[#f6f7f9] p-8" id="v-pills-tabContent">
        <div
          id={DASHBOARD_TABS.REQUEST_A_NURSE}
          role="tabpanel"
          aria-labelledby={DASHBOARD_TABS.REQUEST_A_NURSE}
          className="block opacity-100"
        >
          <Typography
            variant="darkBackgroundHeading"
            as="h3"
            className="animate-fade-in-up"
          >
            Request A Nurse
          </Typography>
          {ordersIsLoading ? (
            <OrderTableShimmer />
          ) : !ordersIsLoading && !orders?.length ? (
            <div className="w-fit mx-auto px-4">
              <div className="rounded-[20px] min-h-[40vh] lg:min-h-[35vh] flex items-center justify-center">
                <AppEmptyState message="No orders found." />
              </div>
            </div>
          ) : !ordersIsLoading && ordersError ? (
            <div className="w-fit mx-auto px-4">
              <div className="rounded-[20px] min-h-[40vh] lg:min-h-[35vh] flex items-center justify-center">
                <AppErrorState message="Failed to load orders." />
              </div>
            </div>
          ) : orders?.length > 0 && !ordersIsLoading ? (
            <TableGrid
              columns={[...orderColumns.filter((col) => col.accessor !== "id")]}
              data={orders.map((o) => ({
                id: o.Id,
                product: o.ProductName,
                total: `$${o.TotalPaid.toFixed(2)}`,
                date: o.DatePlaced
                  ? new Date(o.DatePlaced).toLocaleString(undefined, {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                  : "—",
                orderStatus: capitalize(o.Status),
              }))}
              onRowClick={(row) => handleRowClick(row.id, row.product)}
              renderActions={(
                row  
              ) => (
                 <Button
                                variant="secondary"
                                size="md"
                                className="hidden md:flex lg:flex"
                                aria-label="Request a nurse service"
                                onClick={(e) => {
                                  e.stopPropagation();  
                                  handleRowClick(row.id, row.product);
                                }}
                              >Contact
                              </Button> 
              )}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
      <ContactANurseModal
        isOpen={isContactNurseModalOpen}
        onClose={closeContactNurseModal}
        orderId={OrderModal?.orderId ?? 0}
        productName={OrderModal?.productName ?? ""}
      />
    </>
  );
};
export default RequestANurseSection;
